import { FC, SVGProps } from "react";

interface NotificationSvgProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

const NotificationSvg: FC<NotificationSvgProps> = ({ color = "#2A2D31", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.994 13V9c0-3.314 2.689-6 6.006-6a6.003 6.003 0 0 1 6.006 6v4c0 .986.448 1.919 1.217 2.537l.309.248c.917.736.396 2.215-.78 2.215H5.248c-1.176 0-1.697-1.479-.78-2.215l.309-.248A3.252 3.252 0 0 0 5.994 13Z"
      clipRule="evenodd"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.5 21h3"
    />
  </svg>
);
export default NotificationSvg;
